import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { getUtm } from "../lib/utm";
import { Loader2, Plane } from "lucide-react";

export default function AuthCallback() {
  const { applyUser } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId, ...getUtm() }, { withCredentials: true })
      .then((res) => {
        applyUser(res.data.user);
        // clear the hash and land on the dashboard
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: res.data.user } });
      })
      .catch(() => nav("/login", { replace: true }));
  }, [applyUser, nav]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4" data-testid="auth-callback">
      <div className="h-11 w-11 rounded-sm bg-primary flex items-center justify-center glow-cyan">
        <Plane className="h-6 w-6 text-primary-foreground" strokeWidth={2.5} />
      </div>
      <div className="flex items-center gap-2 text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin text-primary" />
        <span className="font-mono text-sm">Cleared for takeoff — signing you in…</span>
      </div>
    </div>
  );
}
